import { Warning } from '@phosphor-icons/react';

export default function PendingRecoveryCard({ summary, formatCurrency }) {
  if (!summary || summary.total_pending <= 0) return null;
  return (
    <div className="bg-amber-50 border border-amber-300 rounded-lg p-4" data-testid="pending-recovery-card">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Warning size={20} weight="fill" className="text-amber-600" />
          <span className="font-semibold text-amber-800">Payment Recovery Pending</span>
        </div>
        <a href="/payment-recovery" className="text-xs text-[#002FA7] hover:underline font-medium">View Details →</a>
      </div>
      <div className="grid grid-cols-3 gap-3 mt-3">
        <div className="text-center">
          <p className="text-[10px] text-amber-600 uppercase font-semibold">Total Bookings</p>
          <p className="text-lg font-bold text-amber-700 font-mono">{formatCurrency(summary.total_booking_amount)}</p>
        </div>
        <div className="text-center">
          <p className="text-[10px] text-green-600 uppercase font-semibold">Deposits Received</p>
          <p className="text-lg font-bold text-green-700 font-mono">{formatCurrency(summary.total_deposits)}</p>
        </div>
        <div className="text-center">
          <p className="text-[10px] text-red-600 uppercase font-semibold">Pending</p>
          <p className="text-lg font-bold text-red-700 font-mono">{formatCurrency(summary.total_pending)}</p>
        </div>
      </div>
    </div>
  );
}
